import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import style from './style.module.scss'

const Helper = ({ children }) => (
  <Tooltip title={children}>
    <QuestionCircleOutlined className={style.icon} size="small" />
  </Tooltip>
)

export default Helper;
